import jwt_decode from "jwt-decode";
import { environment } from "src/environments/environment";

// Validates car lists responses
export function checkArrayStringType(value: any) {
  var arrayIsString = true;

  try {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        arrayIsString = false;
      } else {
        value.forEach(function (item) {
          if (typeof item !== "string") {
            arrayIsString = false;
          }
        });
      }

      return arrayIsString;
    } else {
      arrayIsString = false;

      return arrayIsString;
    }
  } catch (error) {
    arrayIsString = false;

    return arrayIsString;
  }
}

export function checkArrayIsObject(value: any) {
  var arrayIsObject = true;

  try {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        arrayIsObject= false;
      }

      return arrayIsObject;
    } else {
      arrayIsObject = false;

      return arrayIsObject;
    }
  } catch (error) {
    arrayIsObject = false;

    return arrayIsObject;
  }
}

export function decodeLogbookJWTToken(token: string): TokenData {
  const decoded: TokenData = jwt_decode(token);
  if (!environment.production) console.log('TOKEN >>\n', decoded);
  return decoded;
  
}

export function roundUp(num: number, decimalPlaces: number = 0): number {
  const factor = Math.pow(10, decimalPlaces);
  return Math.ceil(num * factor) / factor;
}

interface AdditionalData {
  BodyType: string;
  Registration: string;
  Colour: string;
  ChassisFrame: string;
  FuelType: string;
  MakeofVehicle: string;
  DateofRegistration: string;
  Ratingcc: string;
  ManufactureYear: string;
  EntryNo: string;
  EngineNo: string;
  TypeofVehicle: string;
  NumberofPreviousOwners: string;
  NumberofPassengers: string;
  TareWeightKgs: string;
  TaxClass: string;
  Duty: string;
  PreviousRegistration: string;
  NoofAxles: string;
  Model: string;
  Code: string;
  BoxNo: string;
  PIN: string;
  No: string;
  OwnersName: string;
  Town: string;
  Ownersignature: string;
  PreviousRegCountry: string;
  GrossWeightKgs: string;
  ForOfficialUseOnlyAuthorisingSignatureandOfficialSeal: string;
  LoadCapacityKgs: string;
  RC: string;

  windscreen: boolean;
  windscreenAmount: string;
  entertainment: boolean;
  entertainmentAmount: string;
  courtesyCar: boolean;
  courtesyCarLimit: string;
  ownDamageProtector: boolean;
  theftProtector: boolean;
  politicalViolence: boolean;
  passLiability: boolean;

  IDNumber: string;
  DateOfIssue: string;
  DOB: string;
  IDType: string;

  email: string;
}

export interface TokenData {
  phoneNo: string;
  additionalData: AdditionalData;
  iat: number;
  exp: number;
}
